(function () {
  const container = document.getElementById('ai-design-generator');
  if (!container) return;

  const canvas = document.getElementById('ai-design-canvas');
  const ctx = canvas.getContext('2d');
  const form = document.getElementById('ai-form');
  const promptEl = document.getElementById('ai-prompt');
  const styleEl = document.getElementById('ai-style');
  const charcount = document.getElementById('ai-charcount');
  const loadingEl = document.getElementById('ai-loading');
  const errorEl = document.getElementById('ai-error');
  const btnEl = document.getElementById('ai-generate-btn');
  const resetBtn = document.getElementById('ai-reset-btn');
  const nightBtn = document.getElementById('ai-night-btn');
  const hintEl = document.getElementById('ai-hint');
  const optionsEl = document.getElementById('ai-options');
  const optionsGridEl = document.getElementById('ai-options-grid');
  const previewModal = document.getElementById('ai-preview-modal');
  const previewImg = document.getElementById('ai-preview-img');
  const previewApprove = document.getElementById('ai-preview-approve');
  const previewCancel = document.getElementById('ai-preview-cancel');
  const previewCheckbox = document.getElementById('ai-preview-checkbox');

  const API_ENDPOINT = container.dataset.apiEndpoint;
  const API_KEY = container.dataset.apiKey || '';
  const PRODUCT_IMAGE = container.dataset.productImage;

  // Fixed insert area (frame boundary) — computed once from product image
  var insertRect = { x: 0, y: 0, w: 0, h: 0 };

  // AI image position/scale state — this is what the customer drags/zooms
  var aiImgState = { x: 0, y: 0, w: 0, h: 0 };

  var frameImg = null;
  var currentAiImg = null;
  var nightMode = false;
  var uploadInProgress = false;
  var rotation = 0; // degrees: 0, 90, 180, 270

  // Interaction state
  var dragging = false;
  var resizing = false;
  var rotating = false;
  var rotateStartAngle = 0;
  var rotateStartRotation = 0;
  var resizeStartDist = 0;
  var pointerStart = { x: 0, y: 0 };
  var imgSnapshot = { x: 0, y: 0, w: 0, h: 0 };

  // Pinch-to-zoom state
  var pinchStartDist = 0;
  var pinchStartScale = 1;

  // Insert area from section settings (percentages of frame image)
  var INSERT_PCT = {
    x: parseFloat(container.dataset.insertX) / 100 || 0.12,
    y: parseFloat(container.dataset.insertY) / 100 || 0.08,
    w: parseFloat(container.dataset.insertWidth) / 100 || 0.76,
    h: parseFloat(container.dataset.insertHeight) / 100 || 0.76,
  };

  // Product form elements
  var productFormEl = document.querySelector('product-form');
  var addToCartBtn = productFormEl
    ? productFormEl.querySelector('button[type="submit"], .product-form__submit')
    : null;

  function computeInsertRect() {
    insertRect.x = canvas.width * INSERT_PCT.x;
    insertRect.y = canvas.height * INSERT_PCT.y;
    insertRect.w = canvas.width * INSERT_PCT.w;
    insertRect.h = canvas.height * INSERT_PCT.h;
  }

  function resetImagePosition() {
    if (!currentAiImg) return;
    // Fit image to cover the insert area (cover, not contain)
    var imgAspect = currentAiImg.naturalWidth / currentAiImg.naturalHeight;
    var insertAspect = insertRect.w / insertRect.h;
    if (imgAspect > insertAspect) {
      aiImgState.h = insertRect.h;
      aiImgState.w = insertRect.h * imgAspect;
    } else {
      aiImgState.w = insertRect.w;
      aiImgState.h = insertRect.w / imgAspect;
    }
    aiImgState.x = insertRect.x + (insertRect.w - aiImgState.w) / 2;
    aiImgState.y = insertRect.y + (insertRect.h - aiImgState.h) / 2;
  }

  function loadFrame() {
    if (!PRODUCT_IMAGE) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      frameImg = img;
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      computeInsertRect();
      draw();
    };
    img.src = PRODUCT_IMAGE;
  }

  // --- Resize handles ---

  function getHandleSize() {
    // Scale handle size relative to canvas display size so it's tappable on mobile
    var displayWidth = canvas.getBoundingClientRect().width || canvas.width;
    return Math.max(24, canvas.width / displayWidth * 20);
  }

  function getHandleCorners() {
    var s = getHandleSize();
    return [
      { x: insertRect.x - s / 2,                y: insertRect.y - s / 2,                cursor: 'nwse-resize' }, // top-left
      { x: insertRect.x + insertRect.w - s / 2,  y: insertRect.y - s / 2,                cursor: 'nesw-resize' }, // top-right
      { x: insertRect.x + insertRect.w - s / 2,  y: insertRect.y + insertRect.h - s / 2,  cursor: 'nwse-resize' }, // bottom-right
      { x: insertRect.x - s / 2,                y: insertRect.y + insertRect.h - s / 2,  cursor: 'nesw-resize' }, // bottom-left
    ];
  }

  function hitTestHandle(pos) {
    if (!currentAiImg) return -1;
    var corners = getHandleCorners();
    var s = getHandleSize();
    // Use a generous hit area (1.5x) for easier tapping on mobile
    var hitPad = s * 0.75;
    for (var i = 0; i < corners.length; i++) {
      var cx = corners[i].x + s / 2;
      var cy = corners[i].y + s / 2;
      if (Math.abs(pos.x - cx) < s / 2 + hitPad && Math.abs(pos.y - cy) < s / 2 + hitPad) return i;
    }
    return -1;
  }

  function getRotateHandle() {
    var s = getHandleSize();
    var stemLen = s * 2.5;
    var cx = insertRect.x + insertRect.w / 2;
    var cy = insertRect.y - stemLen;
    return { x: cx, y: cy, stemTop: insertRect.y, radius: s * 0.7 };
  }

  function hitTestRotateHandle(pos) {
    if (!currentAiImg) return false;
    var rh = getRotateHandle();
    var dx = pos.x - rh.x;
    var dy = pos.y - rh.y;
    var hitRadius = rh.radius * 2;
    return (dx * dx + dy * dy) <= hitRadius * hitRadius;
  }

  function getAngleFromCenter(pos) {
    var cx = insertRect.x + insertRect.w / 2;
    var cy = insertRect.y + insertRect.h / 2;
    return Math.atan2(pos.x - cx, -(pos.y - cy)) * 180 / Math.PI;
  }

  function drawHandles() {
    if (!currentAiImg) return;
    var corners = getHandleCorners();
    var s = getHandleSize();
    ctx.save();
    for (var i = 0; i < corners.length; i++) {
      var c = corners[i];
      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
      ctx.strokeStyle = '#fae8ab';
      ctx.lineWidth = Math.max(2, canvas.width / 500);
      ctx.setLineDash([]);
      ctx.fillRect(c.x, c.y, s, s);
      ctx.strokeRect(c.x, c.y, s, s);
    }
    ctx.restore();

    // Rotation handle
    var rh = getRotateHandle();
    ctx.save();
    ctx.setLineDash([]);
    ctx.strokeStyle = '#fae8ab';
    ctx.lineWidth = Math.max(2, canvas.width / 500);
    ctx.beginPath();
    ctx.moveTo(rh.x, rh.stemTop);
    ctx.lineTo(rh.x, rh.y);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(rh.x, rh.y, rh.radius, 0, Math.PI * 2);
    ctx.fillStyle = '#365417';
    ctx.fill();
    ctx.strokeStyle = '#fae8ab';
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(rh.x, rh.y, rh.radius * 0.45, -Math.PI * 0.8, Math.PI * 0.4);
    ctx.strokeStyle = '#fae8ab';
    ctx.lineWidth = Math.max(2, canvas.width / 600);
    ctx.stroke();
    var tipAngle = Math.PI * 0.4;
    var tipX = rh.x + Math.cos(tipAngle) * rh.radius * 0.45;
    var tipY = rh.y + Math.sin(tipAngle) * rh.radius * 0.45;
    var arrowLen = rh.radius * 0.3;
    ctx.beginPath();
    ctx.moveTo(tipX - arrowLen * 0.5, tipY - arrowLen);
    ctx.lineTo(tipX, tipY);
    ctx.lineTo(tipX + arrowLen, tipY - arrowLen * 0.3);
    ctx.strokeStyle = '#fae8ab';
    ctx.stroke();
    ctx.restore();
  }

  // --- Rotated image drawing helper ---

  function drawRotatedImg(targetCtx, x, y, w, h) {
    if (!currentAiImg) return;
    var cx = x + w / 2;
    var cy = y + h / 2;
    targetCtx.save();
    targetCtx.translate(cx, cy);
    targetCtx.rotate(rotation * Math.PI / 180);
    targetCtx.drawImage(currentAiImg, -w / 2, -h / 2, w, h);
    targetCtx.restore();
  }

  // --- Drawing ---

  // --- Frame visibility overlay (calibrated 2026-07 with the ruler insert):
  // the physical frame lip hides 0.75" of print on every side, and the
  // insert's bottom-left / bottom-right corners are cut off at 45°. The
  // visible area is drawn as a rectangle with those corners chamfered.
  var SIGN_LONG_SIDE_IN = 23.6267; // the insert maps to the 23.63" x 18" print
  var FRAME_OVERLAP_IN = 0.75;
  var CORNER_CUT_IN = 0.5; // 45° chamfer legs on the visible boundary

  function traceVisibleArea(o, c) {
    var x0 = insertRect.x, y0 = insertRect.y, w = insertRect.w, h = insertRect.h;
    ctx.moveTo(x0 + o, y0 + o);
    ctx.lineTo(x0 + w - o, y0 + o);
    ctx.lineTo(x0 + w - o, y0 + h - o - c);
    ctx.lineTo(x0 + w - o - c, y0 + h - o);
    ctx.lineTo(x0 + o + c, y0 + h - o);
    ctx.lineTo(x0 + o, y0 + h - o - c);
    ctx.closePath();
  }

  function drawFrameVisibilityOverlay() {
    if (!insertRect.w || !insertRect.h) return;
    var pxPerIn = insertRect.w / SIGN_LONG_SIDE_IN;
    var o = FRAME_OVERLAP_IN * pxPerIn; // hidden band
    var c = CORNER_CUT_IN * pxPerIn; // 45° bottom-corner chamfer

    ctx.save();
    // Hidden region: everything between the insert edge and the chamfered
    // visible area (even-odd fill: insert rect + visible hexagon as the hole).
    ctx.beginPath();
    ctx.rect(insertRect.x, insertRect.y, insertRect.w, insertRect.h);
    traceVisibleArea(o, c);
    ctx.fillStyle = 'rgba(15, 23, 42, 0.45)';
    ctx.fill('evenodd');

    // Boundary of what stays visible in the frame
    ctx.beginPath();
    traceVisibleArea(o, c);
    ctx.setLineDash([14, 10]);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
    ctx.lineWidth = Math.max(2, canvas.width / 600);
    ctx.stroke();
    ctx.restore();
  }

  // Decorate the "Review Your Design" image with the same frame-visibility
  // treatment: shade the 0.75" hidden band and the 45° bottom-corner cuts.
  // Display-only — the clean JPEG is what actually uploads on approve.
  function buildReviewPreview(croppedJpeg, done) {
    var img = new Image();
    img.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;
        var cx = c.getContext('2d');
        cx.drawImage(img, 0, 0);
        var pxPerIn = c.width / SIGN_LONG_SIDE_IN;
        var o = FRAME_OVERLAP_IN * pxPerIn;
        var cut = CORNER_CUT_IN * pxPerIn;
        var trace = function () {
          cx.moveTo(o, o);
          cx.lineTo(c.width - o, o);
          cx.lineTo(c.width - o, c.height - o - cut);
          cx.lineTo(c.width - o - cut, c.height - o);
          cx.lineTo(o + cut, c.height - o);
          cx.lineTo(o, c.height - o - cut);
          cx.closePath();
        };
        cx.beginPath();
        cx.rect(0, 0, c.width, c.height);
        trace();
        cx.fillStyle = 'rgba(15, 23, 42, 0.45)';
        cx.fill('evenodd');
        cx.beginPath();
        trace();
        cx.setLineDash([14, 10]);
        cx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
        cx.lineWidth = Math.max(2, c.width / 600);
        cx.stroke();
        done(c.toDataURL('image/jpeg', 0.9));
      } catch (err) {
        done(croppedJpeg); // fall back to the plain preview
      }
    };
    img.onerror = function () { done(croppedJpeg); };
    img.src = croppedJpeg;
  }

  function draw() {
    if (!frameImg) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (nightMode && currentAiImg) {
      ctx.drawImage(frameImg, 0, 0);
      ctx.fillStyle = 'rgba(0, 0, 0, 0.92)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      var glowSize = 60 * (canvas.width / canvas.getBoundingClientRect().width);
      ctx.save();
      ctx.beginPath();
      ctx.rect(insertRect.x, insertRect.y, insertRect.w, insertRect.h);
      ctx.clip();
      ctx.shadowColor = 'rgba(255, 245, 200, 0.9)';
      ctx.shadowBlur = glowSize;
      drawRotatedImg(ctx, aiImgState.x, aiImgState.y, aiImgState.w, aiImgState.h);
      drawRotatedImg(ctx, aiImgState.x, aiImgState.y, aiImgState.w, aiImgState.h);
      ctx.restore();
      ctx.save();
      ctx.beginPath();
      ctx.rect(insertRect.x, insertRect.y, insertRect.w, insertRect.h);
      ctx.clip();
      drawRotatedImg(ctx, aiImgState.x, aiImgState.y, aiImgState.w, aiImgState.h);
      ctx.restore();
    } else {
      ctx.drawImage(frameImg, 0, 0);

      if (currentAiImg) {
        ctx.globalAlpha = 0.25;
        drawRotatedImg(ctx, aiImgState.x, aiImgState.y, aiImgState.w, aiImgState.h);
        ctx.globalAlpha = 1.0;

        ctx.save();
        ctx.beginPath();
        ctx.rect(insertRect.x, insertRect.y, insertRect.w, insertRect.h);
        ctx.clip();
        drawRotatedImg(ctx, aiImgState.x, aiImgState.y, aiImgState.w, aiImgState.h);
        ctx.restore();
      }

      // Always show dashed yellow border on insert boundary
      ctx.save();
      ctx.setLineDash([12, 8]);
      ctx.strokeStyle = '#fae8ab';
      ctx.lineWidth = Math.max(2, canvas.width / 400);
      ctx.strokeRect(insertRect.x, insertRect.y, insertRect.w, insertRect.h);
      ctx.restore();
    }

    drawFrameVisibilityOverlay();
    drawHandles();
  }

  // --- Coordinate helpers ---

  function canvasCoords(e) {
    var rect = canvas.getBoundingClientRect();
    var sx = canvas.width / rect.width;
    var sy = canvas.height / rect.height;
    var cx, cy;
    if (e.touches) {
      cx = e.touches[0].clientX;
      cy = e.touches[0].clientY;
    } else {
      cx = e.clientX;
      cy = e.clientY;
    }
    return { x: (cx - rect.left) * sx, y: (cy - rect.top) * sy };
  }

  function getTouchDistance(e) {
    var t = e.touches;
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  // --- Pointer handlers ---

  function onDown(e) {
    if (!currentAiImg) return;

    if (e.touches && e.touches.length === 2) {
      pinchStartDist = getTouchDistance(e);
      pinchStartScale = aiImgState.w / (currentAiImg.naturalWidth || 1);
      imgSnapshot = { x: aiImgState.x, y: aiImgState.y, w: aiImgState.w, h: aiImgState.h };
      e.preventDefault();
      return;
    }

    var pos = canvasCoords(e);
    imgSnapshot = { x: aiImgState.x, y: aiImgState.y, w: aiImgState.w, h: aiImgState.h };

    // Check rotation handle first
    if (hitTestRotateHandle(pos)) {
      rotating = true;
      dragging = false;
      resizing = false;
      rotateStartAngle = getAngleFromCenter(pos);
      rotateStartRotation = rotation;
      canvas.style.cursor = 'grabbing';
      e.preventDefault();
      return;
    }

    // Check if pointer hit a resize handle
    var handleIdx = hitTestHandle(pos);
    if (handleIdx >= 0) {
      resizing = true;
      dragging = false;
      var cx = insertRect.x + insertRect.w / 2;
      var cy = insertRect.y + insertRect.h / 2;
      resizeStartDist = Math.sqrt((pos.x - cx) * (pos.x - cx) + (pos.y - cy) * (pos.y - cy));
      canvas.style.cursor = getHandleCorners()[handleIdx].cursor;
      e.preventDefault();
      return;
    }

    dragging = true;
    pointerStart = pos;
    canvas.style.cursor = 'grabbing';
    e.preventDefault();
  }

  function onMove(e) {
    if (!currentAiImg) return;

    if (e.touches && e.touches.length === 2) {
      var dist = getTouchDistance(e);
      var ratio = dist / pinchStartDist;
      var cx = insertRect.x + insertRect.w / 2;
      var cy = insertRect.y + insertRect.h / 2;
      aiImgState.w = imgSnapshot.w * ratio;
      aiImgState.h = imgSnapshot.h * ratio;
      aiImgState.x = cx - (cx - imgSnapshot.x) * ratio;
      aiImgState.y = cy - (cy - imgSnapshot.y) * ratio;
      draw();
      e.preventDefault();
      return;
    }

    if (rotating) {
      var pos = canvasCoords(e);
      var currentAngle = getAngleFromCenter(pos);
      rotation = rotateStartRotation + (currentAngle - rotateStartAngle);
      var snapAngles = [0, 90, 180, -180, -90];
      for (var s = 0; s < snapAngles.length; s++) {
        if (Math.abs(rotation - snapAngles[s]) < 3) { rotation = snapAngles[s]; break; }
      }
      draw();
      e.preventDefault();
      return;
    }

    if (resizing) {
      var pos = canvasCoords(e);
      var cx = insertRect.x + insertRect.w / 2;
      var cy = insertRect.y + insertRect.h / 2;
      var currentDist = Math.sqrt((pos.x - cx) * (pos.x - cx) + (pos.y - cy) * (pos.y - cy));
      var ratio = currentDist / resizeStartDist;
      ratio = Math.max(0.3, Math.min(ratio, 3.0));
      aiImgState.w = imgSnapshot.w * ratio;
      aiImgState.h = imgSnapshot.h * ratio;
      aiImgState.x = cx - (cx - imgSnapshot.x) * ratio;
      aiImgState.y = cy - (cy - imgSnapshot.y) * ratio;
      draw();
      e.preventDefault();
      return;
    }

    if (!dragging) return;
    var pos = canvasCoords(e);
    aiImgState.x = imgSnapshot.x + (pos.x - pointerStart.x);
    aiImgState.y = imgSnapshot.y + (pos.y - pointerStart.y);
    draw();
    e.preventDefault();
  }

  function onUp() {
    if (dragging || resizing || rotating) {
      dragging = false;
      resizing = false;
      rotating = false;
      canvas.style.cursor = 'grab';
    }
  }

  canvas.addEventListener('mousedown', onDown);
  canvas.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);

  canvas.addEventListener('touchstart', onDown, { passive: false });
  canvas.addEventListener('touchmove', function (e) {
    onMove(e);
  }, { passive: false });
  window.addEventListener('touchend', onUp);

  canvas.addEventListener('wheel', function (e) {
    if (!currentAiImg) return;
    e.preventDefault();
    var f = e.deltaY < 0 ? 1.05 : 0.95;
    var cx = insertRect.x + insertRect.w / 2;
    var cy = insertRect.y + insertRect.h / 2;
    aiImgState.w *= f;
    aiImgState.h *= f;
    aiImgState.x = cx - (cx - aiImgState.x) * f;
    aiImgState.y = cy - (cy - aiImgState.y) * f;
    draw();
  }, { passive: false });

  canvas.addEventListener('mousemove', function (e) {
    if (!currentAiImg || dragging || resizing || rotating) return;
    var pos = canvasCoords(e);
    if (hitTestRotateHandle(pos)) {
      canvas.style.cursor = 'crosshair';
    } else if (hitTestHandle(pos) >= 0) {
      canvas.style.cursor = getHandleCorners()[hitTestHandle(pos)].cursor;
    } else {
      canvas.style.cursor = 'grab';
    }
  });

  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      if (!currentAiImg) return;
      rotation = 0;
      resetImagePosition();
      draw();
    });
  }

  if (nightBtn) {
    nightBtn.addEventListener('click', function () {
      if (!currentAiImg) return;
      nightMode = !nightMode;
      nightBtn.textContent = nightMode ? 'Day View' : 'Night Preview';
      draw();
    });
  }

  promptEl.addEventListener('input', function () {
    charcount.textContent = promptEl.value.length;
  });

  // --- Crop extraction ---

  function extractCroppedImage() {
    // Extract at SOURCE resolution, not canvas display resolution.
    var natW = currentAiImg.naturalWidth;
    var natH = currentAiImg.naturalHeight;

    var scaleX = natW / aiImgState.w;
    var scaleY = natH / aiImgState.h;

    var cropW = Math.round(insertRect.w * scaleX);
    var cropH = Math.round(insertRect.h * scaleY);

    var bigW = Math.round(canvas.width * scaleX);
    var bigH = Math.round(canvas.height * scaleY);
    var bigImgX = Math.round(aiImgState.x * scaleX);
    var bigImgY = Math.round(aiImgState.y * scaleY);
    var bigInsertX = Math.round(insertRect.x * scaleX);
    var bigInsertY = Math.round(insertRect.y * scaleY);

    var offscreen = document.createElement('canvas');
    offscreen.width = bigW;
    offscreen.height = bigH;
    var offCtx = offscreen.getContext('2d');

    var cx = bigImgX + natW / 2;
    var cy = bigImgY + natH / 2;
    offCtx.save();
    offCtx.translate(cx, cy);
    offCtx.rotate(rotation * Math.PI / 180);
    offCtx.drawImage(currentAiImg, -natW / 2, -natH / 2, natW, natH);
    offCtx.restore();

    var cropCanvas = document.createElement('canvas');
    cropCanvas.width = cropW;
    cropCanvas.height = cropH;
    var cropCtx = cropCanvas.getContext('2d');
    cropCtx.drawImage(offscreen, bigInsertX, bigInsertY, cropW, cropH, 0, 0, cropW, cropH);
    return cropCanvas.toDataURL('image/jpeg', 0.92);
  }

  // --- Add to Cart intercept ---
  // When customer clicks Add to Cart with an AI image, show print preview first.
  // On approval, upload crop to CDN, inject hidden fields, then submit the real form.

  // Find the actual Add to Cart button (may not exist yet, re-query after DOM moves)
  function getAddToCartBtn() {
    return document.querySelector('[data-main-product-add-to-cart], product-form button[type="submit"]');
  }

  // The ai-design template renders the add-to-cart button server-side `disabled`
  // (+ data-requires-design) so the product can't be added before a design is
  // generated — that was letting it reach fulfilment with no artwork (order
  // #18796). We enable it only once a design has actually loaded.
  function setAddToCartEnabled(enabled) {
    document.querySelectorAll('[data-main-product-add-to-cart][data-requires-design]').forEach(function (b) {
      b.disabled = !enabled;
      b.classList.toggle('disabled', !enabled);
    });
  }

  var _aiApproved = false;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-main-product-add-to-cart], product-form button[type="submit"]');
    if (!btn) return;
    if (_aiApproved) return; // Already approved — let it through
    if (!currentAiImg) {
      // No design generated — block the add so this product can't reach
      // fulfilment with no artwork (order #18796). The button is also
      // server-disabled until a design loads; this is the JS-race backstop.
      e.preventDefault();
      e.stopImmediatePropagation();
      showError('Please generate a design first.');
      return;
    }

    // Intercept: show preview instead
    e.preventDefault();
    e.stopImmediatePropagation();

    try {
      var croppedJpeg = extractCroppedImage();
      previewImg.src = croppedJpeg;
      if (previewCheckbox) { previewCheckbox.checked = false; }
      if (previewApprove) { previewApprove.disabled = true; }
      previewModal.hidden = false;
      previewModal._croppedJpeg = croppedJpeg;
      // Swap in the frame-visibility version (hidden band + corner cuts)
      buildReviewPreview(croppedJpeg, function (decorated) { previewImg.src = decorated; });
    } catch (err) {
      console.error('[ai-design] Crop extraction failed:', err);
      showError('Could not extract design. Try regenerating.');
    }
  }, true); // useCapture — fires before anything else

  if (previewApprove) {
    previewApprove.addEventListener('click', async function () {
      if (uploadInProgress) return;
      uploadInProgress = true;
      previewApprove.disabled = true;
      previewApprove.textContent = 'Uploading\u2026';

      try {
        var croppedJpeg = previewModal._croppedJpeg;

        // Upload to Cloudflare via Atreides
        var res = await fetch(API_ENDPOINT + '/upload-design', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY },
          body: JSON.stringify({ imageData: croppedJpeg }),
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Upload failed');

        // Inject hidden fields into the product form
        var formEl = document.querySelector('product-form form');
        if (formEl) {
          formEl.querySelectorAll('input[name^="properties[_ai-design"]').forEach(function (el) { el.remove(); });

          var inputProd = document.createElement('input');
          inputProd.type = 'hidden';
          inputProd.name = 'properties[_ai-design-production-url]';
          inputProd.value = data.productionUrl;
          formEl.appendChild(inputProd);

          var inputPreview = document.createElement('input');
          inputPreview.type = 'hidden';
          inputPreview.name = 'properties[_ai-design-preview]';
          inputPreview.value = data.previewUrl;
          formEl.appendChild(inputPreview);
        }

        // Close modal and let the real Add to Cart through
        previewModal.hidden = true;
        _aiApproved = true;

        var realBtn = getAddToCartBtn();
        // Ensure our own gate isn't what blocks this programmatic submit.
        if (realBtn) { realBtn.disabled = false; realBtn.click(); }

        // Reset flag after a tick so future adds go through preview again
        setTimeout(function () { _aiApproved = false; }, 500);
      } catch (err) {
        showError('Upload failed: ' + err.message);
        previewModal.hidden = true;
      } finally {
        uploadInProgress = false;
        previewApprove.disabled = false;
        previewApprove.textContent = 'Add to Cart';
      }
    });
  }

  if (previewCancel) {
    previewCancel.addEventListener('click', function () {
      previewModal.hidden = true;
    });
  }

  if (previewCheckbox && previewApprove) {
    previewCheckbox.addEventListener('change', function () {
      previewApprove.disabled = !previewCheckbox.checked;
    });
  }

  // --- Form submit (generate) ---

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    var prompt = promptEl.value.trim();
    if (!prompt) { showError('Please enter a design description.'); return; }

    hideError();
    setLoading(true);

    // Clear any previous design approval state
    if (productFormEl) productFormEl._aiDesignApproved = false;
    var formEl = productFormEl ? productFormEl.querySelector('form') : null;
    if (formEl) {
      formEl.querySelectorAll('input[name^="properties[_ai-design"]').forEach(function (el) { el.remove(); });
    }

    try {
      var res = await fetch(API_ENDPOINT + '/generate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY },
        body: JSON.stringify({ prompt: prompt, style: styleEl.value || undefined }),
      });
      var data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Generation failed');
      showOptions(data.imageUrls);
      await loadAiImage(data.imageUrls[0]);
    } catch (err) {
      showError(err.message);
    } finally {
      setLoading(false);
    }
  });

  // --- Exact fit on load: contain the whole generated design + pad to fill the
  // insert (detected background colour, no margin) so nothing is cropped. The
  // design becomes the entire sign; from here a customer only ever zooms IN,
  // never out. Mirrors the dashboard Custom Order tool / upload-design editor.
  // (The two storefront generators intentionally duplicate this kind of helper.)

  function median(arr) {
    arr.sort(function (a, b) { return a - b; });
    return arr[Math.floor(arr.length / 2)];
  }

  function detectBackgroundColor(img) {
    var SAMPLE = 200;
    var scale = Math.min(1, SAMPLE / Math.max(img.naturalWidth, img.naturalHeight));
    var sw = Math.max(2, Math.round(img.naturalWidth * scale));
    var sh = Math.max(2, Math.round(img.naturalHeight * scale));
    var c = document.createElement('canvas');
    c.width = sw; c.height = sh;
    var cx = c.getContext('2d');
    cx.fillStyle = '#ffffff';
    cx.fillRect(0, 0, sw, sh);
    cx.drawImage(img, 0, 0, sw, sh);
    var data = cx.getImageData(0, 0, sw, sh).data;
    var band = Math.max(1, Math.round(Math.min(sw, sh) * 0.05));
    var rs = [], gs = [], bs = [];
    for (var y = 0; y < sh; y++) {
      for (var x = 0; x < sw; x++) {
        if (x >= band && x < sw - band && y >= band && y < sh - band) continue;
        var i = (y * sw + x) * 4;
        rs.push(data[i]); gs.push(data[i + 1]); bs.push(data[i + 2]);
      }
    }
    return [median(rs), median(gs), median(bs)];
  }

  // Contain the image inside a canvas with the INSERT's aspect ratio and pad the
  // letterbox with bgColor (margin 0). Result exactly fills the insert — no crop,
  // no transparent/black bars.
  function buildExactFit(img, bgColor) {
    var W0 = img.naturalWidth, H0 = img.naturalHeight;
    var A = (insertRect.w && insertRect.h) ? insertRect.w / insertRect.h : 7088 / 5400;
    var R0 = W0 / H0;
    var canvasW, canvasH;
    if (R0 > A) { canvasW = W0; canvasH = W0 / A; }
    else { canvasH = H0; canvasW = H0 * A; }
    var cap = Math.min(1, 5400 / Math.max(canvasW, canvasH));
    canvasW = Math.round(canvasW * cap);
    canvasH = Math.round(canvasH * cap);
    var s = Math.min(canvasW / W0, canvasH / H0);
    var drawnW = W0 * s, drawnH = H0 * s;
    var c = document.createElement('canvas');
    c.width = canvasW; c.height = canvasH;
    var cx = c.getContext('2d');
    cx.fillStyle = 'rgb(' + bgColor[0] + ',' + bgColor[1] + ',' + bgColor[2] + ')';
    cx.fillRect(0, 0, canvasW, canvasH);
    cx.drawImage(img, (canvasW - drawnW) / 2, (canvasH - drawnH) / 2, drawnW, drawnH);
    return c.toDataURL('image/png');
  }

  function applyAiImage(img) {
    rotation = 0;
    currentAiImg = img;
    try {
      var dataUrl = buildExactFit(img, detectBackgroundColor(img));
      var padded = new Image();
      padded.onload = function () {
        currentAiImg = padded;
        rotation = 0;
        resetImagePosition();
        draw();
        showControls();
      };
      padded.onerror = function () {
        resetImagePosition();
        draw();
        showControls();
      };
      padded.src = dataUrl;
    } catch (e) {
      // getImageData throws if the image is cross-origin/tainted — fall back to
      // plain cover fit (what this editor did before).
      resetImagePosition();
      draw();
      showControls();
    }
  }

  async function loadAiImage(url) {
    rotation = 0;
    try {
      var img = await loadImageWithCors(url);
      applyAiImage(img);
      return;
    } catch (_) {}

    var proxyUrl = API_ENDPOINT + '/proxy-image?url=' + encodeURIComponent(url)
      + '&x-api-key=' + encodeURIComponent(API_KEY);
    var img = await loadImageWithCors(proxyUrl);
    applyAiImage(img);
  }

  function loadImageWithCors(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('Failed to load image')); };
      img.src = src;
    });
  }

  function setLoading(on) {
    loadingEl.hidden = !on;
    btnEl.disabled = on;
    btnEl.textContent = on ? 'Generating\u2026' : 'Generate Design';
  }

  function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
  function hideError() { errorEl.hidden = true; }

  function showOptions(imageUrls) {
    optionsGridEl.innerHTML = '';
    imageUrls.forEach(function (url, i) {
      var thumb = document.createElement('img');
      thumb.className = 'ai-design-generator__thumb';
      thumb.src = API_ENDPOINT + '/proxy-image?url=' + encodeURIComponent(url)
        + '&x-api-key=' + encodeURIComponent(API_KEY);
      thumb.alt = 'Option ' + (i + 1);
      if (i === 0) thumb.classList.add('ai-design-generator__thumb--selected');
      thumb.addEventListener('click', function () {
        optionsGridEl.querySelectorAll('.ai-design-generator__thumb--selected')
          .forEach(function (el) { el.classList.remove('ai-design-generator__thumb--selected'); });
        thumb.classList.add('ai-design-generator__thumb--selected');
        loadAiImage(url);
      });
      optionsGridEl.appendChild(thumb);
    });
    optionsEl.hidden = false;
  }

  function showControls() {
    if (resetBtn) resetBtn.hidden = false;
    if (nightBtn) nightBtn.hidden = false;
    if (hintEl) hintEl.hidden = false;
    setAddToCartEnabled(true); // a design is loaded — safe to allow add-to-cart
  }

  // Move preview modal to body so it's not hidden when section wrapper is hidden
  if (previewModal) {
    document.body.appendChild(previewModal);
  }

  // Move AI generator into the gallery column for side-by-side PDP layout
  var galleryWrap = document.querySelector('product-page .flickity-container');
  if (galleryWrap) {
    var sectionWrap = container.closest('.ai-design-generator-section');
    Array.from(galleryWrap.children).forEach(function (child) {
      child.style.display = 'none';
    });
    galleryWrap.classList.remove('element--is-sticky');
    galleryWrap.appendChild(container);
    if (sectionWrap) sectionWrap.style.display = 'none';
  }

  loadFrame();

  // --- First-visit onboarding overlay ---
  if (!localStorage.getItem('ai-design-onboarded')) {
    var overlay = document.createElement('div');
    overlay.className = 'ai-design-generator__onboarding';

    var callout = document.createElement('div');
    callout.className = 'ai-design-generator__onboarding-callout';
    callout.innerHTML = 'Describe your sign below<span class="ai-design-generator__onboarding-arrow">&#8595;</span>';
    overlay.appendChild(callout);

    document.body.appendChild(overlay);

    // Raise the actual textarea above the overlay so it's visible and clickable
    promptEl.style.position = 'relative';
    promptEl.style.zIndex = '9999';
    promptEl.style.boxShadow = '0 0 0 4px rgba(250, 232, 171, 0.8), 0 0 20px rgba(250, 232, 171, 0.4)';

    // Position callout above the prompt field
    function positionCallout() {
      var promptRect = promptEl.getBoundingClientRect();
      callout.style.left = promptRect.left + 'px';
      callout.style.width = promptRect.width + 'px';
      callout.style.top = (promptRect.top - 60) + 'px';
    }
    positionCallout();

    function dismissOverlay() {
      if (overlay.parentNode) {
        overlay.classList.add('ai-design-generator__onboarding-fade');
        promptEl.style.position = '';
        promptEl.style.zIndex = '';
        promptEl.style.boxShadow = '';
        setTimeout(function () { overlay.remove(); }, 300);
        localStorage.setItem('ai-design-onboarded', '1');
      }
    }

    overlay.addEventListener('click', dismissOverlay);
    overlay.addEventListener('touchstart', dismissOverlay);
    setTimeout(dismissOverlay, 4000);
  }
})();
